












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsEvolutionVisitorsCharts extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop({ default: false })
  planning: boolean;

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {};

  buldChartOptions() {
    this.chartOptions = {
      legend: {
        position: 'bottom'
      },
      height: 350,
      chartArea: { left: '60', top: '20', right: '20', bottom: '100' },
      fontSize: 12,
      hAxis: {
        slantedText: true,
        slantedTextAngle: 45
      },
      vAxis: {
        title: this.planning ? 'Planejadas' : 'Realizadas',
        minValue: 0,
        titleTextStyle: {
          italic: false
        }
      },
      series: {
        [this.getGoalPosition()]: {
          color: '#00AA00',
          lineDashStyle: [12, 6],
          lineWidth: 2,
          pointSize: 0
        }
      }
    };
  }

  mounted() {    
    this.load();
  }

  load() {
    this.buldChartOptions();
    this.chartData = [];
    let map = new Map();
    let dates = new Set<string>();
    let names = new Set<string>();
    this.kpis.forEach((i) => {
      if (!map[i.descPeriodo]) {
        map[i.descPeriodo] = [];
      }
      if (!map[i.descPeriodo][i.nome]) {
        map[i.descPeriodo][i.nome] = [];
      }
      map[i.descPeriodo][i.nome] = this.planning ? i.planejadas : i.realizadas;
      map[i.descPeriodo]['meta'] = i.meta;
      dates.add(i.descPeriodo);
      names.add(i.nome);
    });

    let headers = ['Período'];
    names.forEach((n) => headers.push(StringUtils.abbreviate(n, 20)));
    if (!this.planning) {
      headers.push('Meta');
    }
    this.chartData.push(headers);
    dates.forEach((d) => {
      let day = [];
      day.push(d);
      names.forEach((n) => {
        let v = map[d][n];
        if (!v) {
          v = 0;
        }
        day.push(v);
      });
      if (!this.planning) {
        day.push(map[d]['meta']);
      }
      this.chartData.push(day);
    });
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }

  getGoalPosition() {
    let names = new Set<string>();
    this.kpis.forEach((i) => {
      names.add(i.nome);
    });
    return names.size;
  }
}
